import { FormSectionHandler } from '../entity.handler';
import { EmailProviderResponse, EmailProviderUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { EntityUtils } from '../utils';

interface EditorValues {
    [key: string]: string;
}

export class EmailProviderParametersSectionHandler implements FormSectionHandler<EmailProviderResponse, EditorValues> {

    type = 'form';
    icon = 'wrench';
    bulk = false;

    title = this.translate('TITLE');
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string,
        public creating: boolean
    ) {
    }

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.EMAILPROVIDER.PARAMETERS.${key}`, values);
    }

    applyUpdate(entity: EmailProviderResponse, payload: EmailProviderUpdateRequest): Promise<EmailProviderResponse> {
        return this.admin.applyUpdate(api => api.entities.updateEmailProvider(entity.id, payload));
    }

    async mapEntityToEditor(entity: EmailProviderResponse): Promise<EditorValues> {
        return entity.parameters || {};
    }

    mapEditorToEntity(entity: EmailProviderUpdateRequest, values: EditorValues): Promise<EmailProviderUpdateRequest> {
        const patch: EmailProviderUpdateRequest = {
            parameters: values,
        };
        return Promise.resolve(EntityUtils.mergeFields(['parameters'], patch, entity));
    }

    async getFields(entity: EmailProviderResponse): Promise<FormBuilderField[]> {

        if (entity.type) {
            const emailProviderType = await this.admin.getCached(`getEmailProviderType/${entity.type.id}`, api => api.entities.getEmailProviderType(entity.type.id));
            const params = JSON.parse(emailProviderType.parameterDefinition);
            const fields: FormBuilderField[] = [];
            params.groups.forEach(group => {
                group.fields.forEach(field => {
                    fields.push(field);
                });
            });
            return EntityUtils.prepareBulk(!entity, [], fields);
        } else {
            return [];
        }

    }

}
